<script>
  import { t, language } from '../i18n/i18n'

  export let plan

  const plans = {
    basic: 'basic',
    pro: 'pro'
  }
</script>

<style>
  h2 {
    font-size: 2.4rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  h2 span:last-child {
    text-align: end;
  }
  ul {
    padding: 1rem;
    min-height: 12rem;
  }

  li {
    list-style-type: disc;
    margin-left: 2rem;
  }

  h2 span:last-child {
    margin-left: auto;
    margin-right: 0;
  }
</style>

<div>
  {#if plan === plans.basic}
    <h2>
      <span>{$t['Basic']}</span>
      <span>{Intl.NumberFormat($language, { style: 'currency', currency: 'CAD' }).format(53)} / {$t.month}</span>
    </h2>
    <ul>
      <li>{$t['Unlimited Clients']}</li>
      <li>{$t['Unlimited Locations']}</li>
      <li>{$t['Up to 3 Employees']}</li>
      <li>{$t['1 Administrator']}</li>
    </ul>
  {/if}
  {#if plan === plans.pro}
    <h2>
      <span>{$t.professional}</span>
      <span>{Intl.NumberFormat($language, { style: 'currency', currency: 'CAD' }).format(250)} / {$t.month}</span>
    </h2>
    <ul>
      <li>{$t['Unlimited Clients']}</li>
      <li>{$t['Unlimited Locations']}</li>
      <li>{$t['Up to 35 Employees']}</li>
      <li>{$t['Any number of Administrators']}</li>
    </ul>
  {/if}
</div>
